<template>
    <templatesite>
        <template v-slot:appheader>  <appheader></appheader> </template>
        <template v-slot:appsidebar>  <appsidebar></appsidebar>  </template>

        <template v-slot:appcontent>
            <div class="content" style="margin-top: 0">
                <div class="main-content">

                    <!-- En-tête de page -->
                    <div class="ds-page-head">
                        <div>
                            <h1 class="ds-page-head__title">
                                <i class="ri-download-cloud-2-line"></i> Utilitaires &amp; logiciels à installer
                            </h1>
                            <p class="ds-page-head__sub">
                                Téléchargez et installez les outils nécessaires au bon fonctionnement de l'application sur ce poste.
                            </p>
                        </div>
                        <div class="cf-tool-grp">
                            <span class="cf-chip cf-chip--info"><b>{{ logiciels.length }}</b>&nbsp;logiciel(s)</span>
                        </div>
                    </div>

                    <!-- Note d'information -->
                    <div class="cf-note cf-note--info ut-note">
                        <i class="ri-information-fill"></i>
                        <p class="ut-note__txt">
                            Ces logiciels s'installent sur l'ordinateur relié au matériel (imprimante, tiroir-caisse).
                            Chaque bouton ouvre le lien de téléchargement officiel dans un nouvel onglet.
                        </p>
                    </div>

                    <!-- Cards grid -->
                    <div class="ut-grid">
                        <div
                            v-for="soft in logiciels"
                            :key="soft.id"
                            class="cf-card cf-card--piece ut-card"
                        >
                            <!-- Icon + badge -->
                            <div class="ut-card__top">
                                <div class="ut-card__icon" :class="soft.iconBg">
                                    <i class="bx side-menu__icon text-2xl" :class="[soft.icon, soft.iconColor]"></i>
                                </div>
                                <span
                                    class="px-2.5 py-1 text-xs font-semibold rounded-full"
                                    :class="badgeClass(soft.categorie)"
                                >
                                    {{ soft.categorie }}
                                </span>
                            </div>

                            <!-- Title -->
                            <h3 class="ut-card__title">
                                {{ soft.nom }}
                            </h3>

                            <!-- Description -->
                            <p class="ut-card__desc">
                                {{ soft.description }}
                            </p>

                            <!-- Meta -->
                            <div class="ut-card__meta">
                                <span class="ut-card__meta-item">
                                    <i class="ri-computer-line"></i>
                                    {{ soft.plateforme }}
                                </span>
                                <span v-if="soft.version" class="ut-card__meta-item">
                                    <i class="ri-price-tag-3-line"></i>
                                    v{{ soft.version }}
                                </span>
                            </div>

                            <!-- Download button -->
                            <div class="ut-card__foot">
                                <a
                                    :href="soft.url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="ti-btn ti-btn-primary-full w-full !font-medium !text-[0.8rem]"
                                >
                                    <i class="ri-download-line"></i>
                                    Télécharger
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </templatesite>
</template>

<script>
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";

    export default {
        /* eslint-disable */
        name: "utilitaires",

        components: {
            templatesite,
            appheader,
            appsidebar,
        },

        data() {
            return {
                // Catalogue statique des logiciels utilitaires à installer.
                // Pour ajouter un logiciel : dupliquer un objet et renseigner ses champs.
                logiciels: [
                    {
                        id: 'qztray',
                        nom: 'QZ Tray',
                        categorie: 'Requis',
                        description: "Service d'impression et de pilotage matériel. Requis pour l'ouverture automatique du tiroir-caisse depuis la caisse.",
                        plateforme: 'Windows / macOS / Linux',
                        version: '',
                        url: 'https://qz.io/download/',
                        icon: 'bx-printer',
                        iconBg: 'bg-blue-100 dark:bg-blue-900',
                        iconColor: 'text-blue-600 dark:text-blue-400',
                    },
                    {
                        id: 'xprinter',
                        nom: 'Pilote Xprinter (POS)',
                        categorie: 'Pilote',
                        description: "Pilote pour les imprimantes ticket thermiques Xprinter (imprimante de reçus / POS). À installer sur le poste connecté à l'imprimante.",
                        plateforme: 'Windows',
                        version: '',
                        url: 'https://filedn.com/l3YHTxXEORjSP7vqHLwob1f/Xprinter/',
                        icon: 'bx-receipt',
                        iconBg: 'bg-purple-100 dark:bg-purple-900',
                        iconColor: 'text-purple-600 dark:text-purple-400',
                    },
                    // autres entrées éventuelles à compléter ici
                ],
            };
        },

        methods: {
            badgeClass(categorie) {
                switch ((categorie || '').toLowerCase()) {
                    case 'requis':
                        return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300';
                    case 'pilote':
                        return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300';
                    case 'impression':
                        return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300';
                    default:
                        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
                }
            },
        },
    };
</script>

<style scoped>
    /* Charte cf-/ds- : tokens uniquement (light-only) */

    .ut-note { margin-bottom: 1.25rem; }
    .ut-note__txt { margin: 0; }

    /* Grille des logiciels */
    .ut-grid {
        display: grid; grid-template-columns: repeat(1, minmax(0, 1fr)); gap: 1rem;
    }
    @media (min-width: 768px)  { .ut-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
    @media (min-width: 1280px) { .ut-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }

    .ut-card {
        display: flex; flex-direction: column;
        box-shadow: var(--cf-shadow-sm);
        transition: box-shadow 0.2s ease, transform 0.2s ease;
        animation: utFadeIn 0.3s ease-out;
    }
    .ut-card:hover { box-shadow: var(--cf-shadow-md); transform: translateY(-2px); }

    .ut-card__top { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 0.9rem; }
    .ut-card__icon {
        padding: 0.75rem; border-radius: var(--cf-radius-sm);
        display: inline-flex; align-items: center; justify-content: center;
    }

    .ut-card__title { font-size: 1rem; font-weight: 700; color: var(--cf-ink-strong); margin: 0; }
    .ut-card__desc { margin: 0.5rem 0 0; font-size: 0.82rem; color: var(--cf-muted); flex-grow: 1; line-height: 1.5; }

    .ut-card__meta {
        margin-top: 0.9rem; display: flex; align-items: center; flex-wrap: wrap;
        gap: 0.25rem 1rem; font-size: 0.72rem; color: var(--cf-faint);
    }
    .ut-card__meta-item { display: inline-flex; align-items: center; gap: 0.3rem; }

    .ut-card__foot { margin-top: 1.25rem; }

    @keyframes utFadeIn {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
    }
</style>
